export default __webpack_public_path__ + "static/media/teslaLogo.d5a41eef.svg";